<template>
    <div v-if="can('reports.ministry')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/">{{i18n('Main')}}</a></li>
                <li class="breadcrumb-item active" aria-current="page"> {{i18n('Reports for Min. Trans.')}}</li>
            </ol>
        </nav>
        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n('Reports for Min. Trans.')}}</h1>
                <button type="button" class="btn base_btn waves-effect waves-light reload-btn btn-primary"
                        @click="loadReports">
                    <i class="mdi mdi-reload"></i>
                </button>
            </div>
        </div>
        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <div v-show="loadingState" class="text-center pt-3 pb-3 border">
                            <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}
                        </div>
                        <div id="table" v-if="this.result.length > 0">
                            <table class="table table-bordered table-striped table-hover mb-0 table-small"
                                   ref="printTable">
                                <thead class="text-center">
                                <tr>
                                    <th scope="col" rowspan="2"></th>
                                    <th scope="col" colspan="3">
                                        {{i18n('Last day')}}
                                    </th>
                                    <th scope="col" colspan="3">
                                        {{i18n('since the beginning of the week')}}
                                    </th>
                                    <th scope="col" colspan="3">
                                        {{i18n('from the beginning of the month')}}
                                    </th>
                                    <th scope="col" colspan="3">
                                        {{i18n('from the beginning of the year')}}
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col">{{i18n('trips')}}</th>
                                    <th scope="col">{{i18n('passenger')}}</th>
                                    <th scope="col">{{i18n('all places')}}</th>

                                    <th scope="col">{{i18n('trips')}}</th>
                                    <th scope="col">{{i18n('passenger')}}</th>
                                    <th scope="col">{{i18n('all places')}}</th>

                                    <th scope="col">{{i18n('trips')}}</th>
                                    <th scope="col">{{i18n('passenger')}}</th>
                                    <th scope="col">{{i18n('all places')}}</th>

                                    <th scope="col">{{i18n('trips')}}</th>
                                    <th scope="col">{{i18n('passenger')}}</th>
                                    <th scope="col">{{i18n('all places')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="table-secondary clickable" @click="toggle(1)" style="font-weight: bold;">
                                    <td><i class="mdi" :class="{'mdi-plus':!canShow(1),'mdi-minus':canShow(1)}"></i> {{ blockAll.napravleniya }}</td>

                                    <td>{{ blockAll.reyslarsonibugun}}</td>
                                    <td>{{ blockAll.passajirlarsonibugun}}</td>
                                    <td>{{ blockAll.joylarsonibugun}}</td>

                                    <td>{{ blockAll.reyslarsonixafta}}</td>
                                    <td>{{ blockAll.passajirlarsonixafta}}</td>
                                    <td>{{ blockAll.joylarsonixafta}}</td>

                                    <td>{{ blockAll.reyslarsonioy}}</td>
                                    <td>{{ blockAll.passajirlarsonioy}}</td>
                                    <td>{{ blockAll.joylarsonioy}}</td>

                                    <td>{{ blockAll.reyslarsoniyil}}</td>
                                    <td>{{ blockAll.passajirlarsoniyil}}</td>
                                    <td>{{ blockAll.joylarsoniyil}}</td>
                                </tr>
                                <tr v-for="item in blockOne" v-show="canShow(1)">
                                    <td>{{ item.napravleniya }}</td>

                                    <td>{{ item.reyslarsonibugun}}</td>
                                    <td>{{ item.passajirlarsonibugun}}</td>
                                    <td>{{ item.joylarsonibugun}}</td>

                                    <td>{{ item.reyslarsonixafta}}</td>
                                    <td>{{ item.passajirlarsonixafta}}</td>
                                    <td>{{ item.joylarsonixafta}}</td>

                                    <td>{{ item.reyslarsonioy}}</td>
                                    <td>{{ item.passajirlarsonioy}}</td>
                                    <td>{{ item.joylarsonioy}}</td>

                                    <td>{{ item.reyslarsoniyil}}</td>
                                    <td>{{ item.passajirlarsoniyil}}</td>
                                    <td>{{ item.joylarsoniyil}}</td>
                                </tr>
                                <tr class="table-secondary clickable" @click="toggle(2)" style="font-weight: bold;">
                                    <td><i class="mdi" :class="{'mdi-plus':!canShow(2),'mdi-minus':canShow(2)}"></i> {{ blockAllOne.napravleniya }}</td>

                                    <td>{{ blockAllOne.reyslarsonibugun}}</td>
                                    <td>{{ blockAllOne.passajirlarsonibugun}}</td>
                                    <td>{{ blockAllOne.joylarsonibugun}}</td>

                                    <td>{{ blockAllOne.reyslarsonixafta}}</td>
                                    <td>{{ blockAllOne.passajirlarsonixafta}}</td>
                                    <td>{{ blockAllOne.joylarsonixafta}}</td>

                                    <td>{{ blockAllOne.reyslarsonioy}}</td>
                                    <td>{{ blockAllOne.passajirlarsonioy}}</td>
                                    <td>{{ blockAllOne.joylarsonioy}}</td>

                                    <td>{{ blockAllOne.reyslarsoniyil}}</td>
                                    <td>{{ blockAllOne.passajirlarsoniyil}}</td>
                                    <td>{{ blockAllOne.joylarsoniyil}}</td>
                                </tr>
                                <tr v-for="item in blockTwo" v-show="canShow(2)">
                                    <td>{{ item.napravleniya }}</td>

                                    <td>{{ item.reyslarsonibugun}}</td>
                                    <td>{{ item.passajirlarsonibugun}}</td>
                                    <td>{{ item.joylarsonibugun}}</td>

                                    <td>{{ item.reyslarsonixafta}}</td>
                                    <td>{{ item.passajirlarsonixafta}}</td>
                                    <td>{{ item.joylarsonixafta}}</td>

                                    <td>{{ item.reyslarsonioy}}</td>
                                    <td>{{ item.passajirlarsonioy}}</td>
                                    <td>{{ item.joylarsonioy}}</td>

                                    <td>{{ item.reyslarsoniyil}}</td>
                                    <td>{{ item.passajirlarsoniyil}}</td>
                                    <td>{{ item.joylarsoniyil}}</td>
                                </tr>
                                <tr class="table-secondary clickable" @click="toggle(3)" style="font-weight: bold;">
                                    <td><i class="mdi" :class="{'mdi-plus':!canShow(3),'mdi-minus':canShow(3)}"></i> {{ blockAllTwo.napravleniya }}</td>

                                    <td>{{ blockAllTwo.reyslarsonibugun}}</td>
                                    <td>{{ blockAllTwo.passajirlarsonibugun}}</td>
                                    <td>{{ blockAllTwo.joylarsonibugun}}</td>

                                    <td>{{ blockAllTwo.reyslarsonixafta}}</td>
                                    <td>{{ blockAllTwo.passajirlarsonixafta}}</td>
                                    <td>{{ blockAllTwo.joylarsonixafta}}</td>

                                    <td>{{ blockAllTwo.reyslarsonioy}}</td>
                                    <td>{{ blockAllTwo.passajirlarsonioy}}</td>
                                    <td>{{ blockAllTwo.joylarsonioy}}</td>

                                    <td>{{ blockAllTwo.reyslarsoniyil}}</td>
                                    <td>{{ blockAllTwo.passajirlarsoniyil}}</td>
                                    <td>{{ blockAllTwo.joylarsoniyil}}</td>
                                </tr>
                                <tr v-for="item in blockThree" v-show="canShow(3)">
                                    <td>{{ item.napravleniya }}</td>

                                    <td>{{ item.reyslarsonibugun}}</td>
                                    <td>{{ item.passajirlarsonibugun}}</td>
                                    <td>{{ item.joylarsonibugun}}</td>

                                    <td>{{ item.reyslarsonixafta}}</td>
                                    <td>{{ item.passajirlarsonixafta}}</td>
                                    <td>{{ item.joylarsonixafta}}</td>

                                    <td>{{ item.reyslarsonioy}}</td>
                                    <td>{{ item.passajirlarsonioy}}</td>
                                    <td>{{ item.joylarsonioy}}</td>

                                    <td>{{ item.reyslarsoniyil}}</td>
                                    <td>{{ item.passajirlarsoniyil}}</td>
                                    <td>{{ item.joylarsoniyil}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="result.length > 0" class="base_box_cnt">
                            <div class="button-group">
                                <button type="button" class="btn base_btn waves-effect waves-light"
                                        @click="exportToExcel">{{i18n('Export to Excel')}}
                                </button>
                                <button type="button" class="btn base_btn waves-effect waves-light" @click="printData">
                                    {{i18n('Print out')}}
                                </button>
                            </div>
                        </div>
                        <div v-show="!loadingState && result.length === 0" class="text-center pt-3 pb-3 border">
                            No items
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MinistryReports",
        data() {
            return {
                loadingState: false,
                result: [],
                showings: [{
                    item: 1,
                    show: true
                }, {
                    item: 2,
                    show: true
                }, {
                    item: 3,
                    show: true
                }]
            };
        },
        methods: {
            printData() {
                let fontSize = this.$refs.printTable.style.fontSize;
                this.$refs.printTable.style.fontSize = '13.5px';
                let mywindow = window.open('', 'PRINT');
                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
                mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById('table').innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close();
                mywindow.focus();
                this.$refs.printTable.style.fontSize = fontSize;

                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 1000)
            },
            exportToExcel() {
                let fileName = 'Отчет_для_МинТранс' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
                this.$api.download('xls.ministry-reports').then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            loadReports() {
                this.loadingState = true;
                this.$api.get('reports.ministry').then(({data}) => {
                    if (data.reports) {
                        this.result = data.reports;
                    }
                }).finally(() => {
                    this.loadingState = false;
                })
            },
            sum(arr, field) {
                return arr.reduce(function (cnt, o) {
                    return cnt + parseInt(o[field]);
                }, 0)
            },
            toggle(i) {
                let showingIndex = this.showings.findIndex(s => s.item === i);
                let showing = this.showings.find(s => s.item === i);
                if (showingIndex > -1) {
                    this.showings[showingIndex] = {
                        item: showing.item,
                        show: !showing.show
                    };
                    this.$forceUpdate();
                }
            },
            canShow(i) {
                return (this.showings.find(s => s.item === i) || {}).show === true;
            }
        },
        computed: {
            blockOne() {
                return this.result.filter(x => parseInt(x.block) === 1);
            },
            blockTwo() {
                return this.result.filter(x => parseInt(x.block) === 2);
            },
            blockThree() {
                return this.result.filter(x => parseInt(x.block) === 3);
            },
            blockAll() {
                return {
                    "block": 0,
                    "napravleniya": 'По всем направлениям',
                    "is_international": 0,
                    "reyslarsonibugun": this.sum(this.blockOne, 'reyslarsonibugun'),
                    "passajirlarsonibugun": this.sum(this.blockOne, 'passajirlarsonibugun'),
                    "joylarsonibugun": this.sum(this.blockOne, 'joylarsonibugun'),
                    "reyslarsonixafta": this.sum(this.blockOne, 'reyslarsonixafta'),
                    "passajirlarsonixafta": this.sum(this.blockOne, 'passajirlarsonixafta'),
                    "joylarsonixafta": this.sum(this.blockOne, 'joylarsonixafta'),
                    "reyslarsonioy": this.sum(this.blockOne, 'reyslarsonioy'),
                    "passajirlarsonioy": this.sum(this.blockOne, 'passajirlarsonioy'),
                    "joylarsonioy": this.sum(this.blockOne, 'joylarsonioy'),
                    "reyslarsoniyil": this.sum(this.blockOne, 'reyslarsoniyil'),
                    "passajirlarsoniyil": this.sum(this.blockOne, 'passajirlarsoniyil'),
                    "joylarsoniyil": this.sum(this.blockOne, 'joylarsoniyil'),
                };
            },
            blockAllOne() {
                return this.blockOne.find(x => parseInt(x.is_international) === 1);
            },
            blockAllTwo() {
                return this.blockOne.find(x => parseInt(x.is_international) === 0);
            }
        },
        created() {
            this.loadReports();
        },
        filters: {
            moneyFormat(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            },
        }
    }
</script>

<style scoped>
    .reload-btn {
        position: absolute;
        right: 0;
        top: 0;
        margin: 12px 32px;
    }

    .clickable {
        cursor: pointer;
    }
</style>
